module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_2"
    }
  }, [_vm._v("A Better Freedom")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Christ revealed himself to me")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Enslaved my soul to set me free")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I was bound to at him at Calvary")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("And found a better freedom")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("That Soul who suffered in the dark")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Has purchased and unchained my heart")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("A shining slavery did impart")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("To find a better freedom")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("A better freedom can’t be found")]), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("By those unwilling to be bound")]), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("A better freedom is not known")]), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("By those whose hearts will not be owned")]), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("But those who follow find a better freedom")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We never can be truly free")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Till we’re bound to this community")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The Incarnation lets us see")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("A path to better freedom")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("A slave to sin, my heart before")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Was bolted like a prison door")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But in slavery to the Risen Lord")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I found a better freedom")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("A better freedom can’t be found")]), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("By those unwilling to be bound")]), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("A better freedom is not known")]), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("By those whose hearts will not be owned")]), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("But those who follow find a better freedom")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("Come with him and find a better freedom")]), _vm._v(" "), _c('p', {
    staticClass: "i"
  }, [_vm._v("Follow me and find a better freedom")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("Music and lyrics by Scott Roley and Michael Card")]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("(Recording available for free download at "), _c('a', {
    attrs: {
      "href": "http://michaelcard.com",
      "target": "_blank"
    }
  }, [_vm._v("michaelcard.com")]), _vm._v(")")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c78205","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ABetterFreedom.vue
// module id = 69
// module chunks = 0